import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      localStorage.removeItem("ap_token");
      localStorage.removeItem("ap_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register") && window.location.pathname !== "/") {
        window.location.href = "/login";
      }
    }
    if (e?.response?.status === 402 && e?.response?.data?.checkout_required) {
      // Paywall: redirect to billing unless we're already there
      if (!window.location.pathname.startsWith("/billing")) {
        window.location.href = "/billing?paywall=1";
      }
    }
    if (e?.response?.status === 403 && e?.response?.data?.upgrade_required) {
      // PRO+ upsell modal — emit a global event so any mounted listener can show the modal
      window.dispatchEvent(new CustomEvent("app:upgrade-required", {
        detail: {
          current_plan: e.response.data.current_plan,
          detail: e.response.data.detail,
        },
      }));
    }
    return Promise.reject(e);
  }
);

export default api;
